import { Component, DestroyRef, Injector, OnInit, inject } from '@angular/core';
import { EprocUser } from '@lib/user';
import { PurchaseRequisitionStatusEnum } from '../../types/PurchaseRequistionStatusEnum';
import { map } from 'rxjs/operators';
import { VisibilityEvaluator } from '@lib/util';
import { View } from '@lib/core';
import { DemandDataService } from '../../../demand/demand-data.service';
import { PurchaseRequisitionDataService } from '../../purchase-requisition-data.service';
import { PurchaseRequisitionListFilter } from '../../types/PurchaseRequisitionListFilter';
import { SHOW_BUTTON } from '@lib/dashboard/widgets/ui';
import { RfqSettingsService } from '../../../rfq-settings.service';
import { firstValueFrom } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'purchase-requisition-info-widget',
    templateUrl: './purchase-requisition-info-widget.component.html',
    styleUrls: ['./purchase-requisition-info-widget.component.scss'],
    standalone: false
})
export class PurchaseRequisitionInfoWidgetComponent extends VisibilityEvaluator implements OnInit {
    private readonly demandDataService = inject(DemandDataService);
    private readonly purchaseRequisitionDataService = inject(PurchaseRequisitionDataService);
    private readonly destroyRef = inject(DestroyRef);

    static override async isVisible(injector: Injector): Promise<boolean> {
        const rfqSettingsService = injector.get(RfqSettingsService);
        return firstValueFrom(rfqSettingsService.purchaseRequisitionActive().pipe(map((result) => result.active)));
    }

    public user?: EprocUser;
    public hasUnannouncedDemand?: boolean;
    public showOnTheWidgetCard = false;
    public openPurchaseRequisitionCount!: number;
    public View = View;

    constructor() {
        const data = inject(SHOW_BUTTON);

        super();
        this.showOnTheWidgetCard = data;
    }

    ngOnInit(): void {
        this.demandDataService
            .hasUnannouncedDemand()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((hasUnannouncedDemand: boolean) => (this.hasUnannouncedDemand = hasUnannouncedDemand));
        const purchaseRequisitionFilter: PurchaseRequisitionListFilter = PurchaseRequisitionListFilter.EMPTY();
        purchaseRequisitionFilter.status = PurchaseRequisitionStatusEnum.PENDING;
        this.purchaseRequisitionDataService
            .countByFilter(purchaseRequisitionFilter)
            .subscribe(
                (openPurchaseRequisitionCount: number) =>
                    (this.openPurchaseRequisitionCount = openPurchaseRequisitionCount),
            );
    }
}
